module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/teaching_progamming_5_11_yr_olds-13f8e75b97d7d432b62030352b2bdd69.jpeg";